$('#site-navigation .menu-toggle').on('click', function() {
    $('body').toggleClass('panel-minimized');
    $('.js-retract').toggleClass('page-shift-left');
    return false;
});

$('#site-branding .menu-toggle').on('click', function() {
    $('body').toggleClass('mobile-menu-visible');
    return false;
});
